import { DigitalAcceptPageBase } from '@/cms/definitions/content-types';
import { CmsRootState } from './store';

export default {
	SET_EPI_ROUTING(state: CmsRootState, epiRouting: []) {
		state.epiRouting = epiRouting;
	},

	SET_USABILLA_COUNT(state: CmsRootState) {
		state.usabilla.count = state.usabilla.count + 1;
	},

	SET_USABILLA_MOUNTED(state: CmsRootState) {
		state.usabilla.mounted = state.usabilla.mounted + 1;
	},

	TOGGLE_MODAL(state: CmsRootState, modalState: { id: string; isActive: boolean }) {
		// Only notify
	},

	setDeviceType(state: CmsRootState, payload) {
		state.isTouchDevice = payload;
	},
};
